/* eslint-disable react-hooks/exhaustive-deps */
import { useDynamicFormFieldById } from 'components/DynamicForm/state';
import React, { useEffect, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Campos from '../Campos/index';

export const YesNoComponent = ({ name = '', id, subCampos, label = '', defaultValue = true }) => {
  const { field } = useDynamicFormFieldById({ fieldId: id });
  const disabled = field?.disabled || false;

  const methods = useFormContext();

  const selected = methods.watch(name);

  const htmlMessage = (mssg, fontSize = '15px') => {
    return (
      <div
        style={{ fontSize: `${fontSize}`, fontFamily: 'Futura-Medium' }}
        dangerouslySetInnerHTML={{
          __html: mssg,
        }}
      />
    );
  };

  useEffect(() => {
    methods.setValue(name, selected === true || selected === false ? selected : defaultValue);
  }, []);

  const newSubCampos = useMemo(() => {
    return (
      subCampos
        ?.filter?.((item) => item?.whenValue === selected)
        ?.map?.((item) => ({
          ...item,
          name: `${name}Fields.${item.name}`,
          containerProps: {
            ...(item?.containerProps || {}),
            name: `${name}Fields.${item.name}`,
          },
        })) || []
    );
  }, [selected]);

  return (
    <React.Fragment>
      <div className="col-md-12 d-flex flex-wrap mt-5 justify-content-around border-bottom pb-2">
        <div className="col-md-8 col-sm-12 text-justify">{htmlMessage(label, '20px')}</div>
        <div className="col-md-2 col-sm-6 d-flex justify-content-end">
          <label className="containerCheck">
            Si
            <Controller
              name={name}
              render={({ value = defaultValue }) => (
                <input
                  name={name}
                  type="checkbox"
                  checked={value}
                  disabled={disabled}
                  onChange={() => {
                    methods.setValue(name, !value);
                  }}
                />
              )}
            />
            <span className="checkmark"></span>
          </label>
        </div>
        <div className="col-md-2 col-sm-6 d-flex justify-content-end">
          <label className="containerCheck">
            No
            <input
              type="checkbox"
              checked={selected === undefined ? false : !selected}
              disabled={disabled}
              onChange={() => {
                methods.setValue(name, selected === undefined ? false : !selected);
              }}
            />
            <span className="checkmark"></span>
          </label>
        </div>
      </div>
      {newSubCampos && newSubCampos?.length > 0 && (
        <div className="col-12">
          <div className="row justify-content-center">
            <div className="col-11">
              <div className="row">
                <Campos campos={newSubCampos} />
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
